import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { CrudService } from "@atenea-cms";
import { Serie } from "./serie.model";

@Injectable()
export class SerieService extends CrudService {
  getRootUrl(): string {
    return "series";
  }

  save(serie: Serie) {
    return super.save(serie);
  }

  saveMultiple(series: Array<Serie>) {
    return super.saveMultiple(series);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/series/shared/serie.service.ts